import { useLocation, useNavigate } from "react-router-dom";
import LocationIcon from "../../../assets/images/marker-03.png";
import { getFacilityDefaultImage } from "./helpers";
import { useTranslation } from "react-i18next";
import { IServiceProvider } from "../../../interface/ProfileInterfaces";
import { highlightSearchString } from "../../../utils/highlightSearchString";
import { GeneralButton, ProfileAvatar } from "../../../components";

const ServiceProviderCard: React.FC<{ item: IServiceProvider }> = ({
  item,
}) => {
  const location = useLocation();
  const currentLocationParams = new URLSearchParams(location.search);
  const searchValue = currentLocationParams.get("search-value") ?? "";
  const highlightedText = highlightSearchString(item?.Name, searchValue);
  const navigate = useNavigate();

  const { t } = useTranslation();

  const facilityName = item?.Name?.replaceAll(" ", "-");
  return (
    <div
      className="lg:hover:bg-primary-bg flex h-fit w-full cursor-pointer items-center justify-between lg:px-2"
      onClick={(event) => {
        event.stopPropagation();
        event?.preventDefault();
        navigate(
          `/search/${facilityName}/${item?.Id}/${item?.ProviderId == "0" ? "location" : "certificates"}?provider=${item?.ProviderId}`,
        );
      }}
    >
      <div
        className={`flex w-full items-center gap-2 rounded-lg border border-white py-2 text-[#D6D6D6] lg:p-2`}
      >
        <div className="relative">
          <ProfileAvatar
            Id={Number(item?.Id)}
            imageToLoad={getFacilityDefaultImage(item?.FacilityType?.Code)}
            className="h-12 w-12 rounded-full !object-cover"
            src={item?.Image}
            alt="provider"
            FullName={item?.Name}
            size="large"
          />
          {item?.ProviderId == 0 && (
            <div
              className={`h-4 w-4 ${item.IsOpen ? "bg-successGreen" : "bg-error"} absolute -end-1 bottom-1 rounded-full border-4 border-white`}
            />
          )}
        </div>
        <div className="flex w-full max-w-[50%] flex-col gap-1 pt-1">
          <div
            className="text-primary-text line-clamp-1 text-sm font-bold leading-tight"
            dangerouslySetInnerHTML={{ __html: highlightedText }}
          />
          <span className="text-body-text block max-w-[30vw] truncate text-xs lg:max-w-[10vw]">
            {item?.Specialties?.map((item: any) => item?.Name).join(",")}
          </span>
          {item?.Address && (
            <div className="mt-1 flex gap-1">
              <img className="h-4 w-4" src={LocationIcon} alt="" />
              <span className="block max-w-[10vw] truncate text-xs text-secondaryDark">
                {item?.Address}
              </span>
            </div>
          )}
        </div>
      </div>

      {item?.CanCall && (
        <GeneralButton
          color={"blue"}
          onClick={(event) => {
            event?.stopPropagation();
            window.location.replace(`tel:${item?.CallNumber}`);
          }}
          styleClasses={`!w-[4.43rem] !px-4 text-sm !rounded-lg !h-8`}
          title={t("call")}
        />
      )}
    </div>
  );
};

export default ServiceProviderCard;
